import { render, staticRenderFns } from "./header.vue?vue&type=template&id=7d205c16&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=7d205c16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d205c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d205c16')) {
      api.createRecord('7d205c16', component.options)
    } else {
      api.reload('7d205c16', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=7d205c16&scoped=true&", function () {
      api.rerender('7d205c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/rosseti/header.vue"
export default component.exports